<!-- Snow.vue -->
<template>
    <div ref="snowRef" class="fixed inset-0 md:z-30 z-8 pointer-events-none"></div>
    <div ref="twinkleRef" class="fixed inset-0 md:z-20 z-8 pointer-events-none"></div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';

const snowflakes = 50;
const twinkles = 100;

const snowRef = ref(null);
const twinkleRef = ref(null);

let cleanup = [];

onMounted(() => {
    const host = snowRef.value;
    const twHost = twinkleRef.value;

    if (host) {
        for (let i = 0; i < snowflakes; i++) {
            const s = document.createElement('div');
            s.className = 'snowflake';

            s.style.left = Math.random() * 100 + 'vw';
            s.style.top = -10 + Math.random() * 10 + 'vh';
            s.style.position = 'absolute';
            s.style.pointerEvents = 'none';
            s.style.color = 'rgba(255,255,255,0.8)';

            const duration = 10 + Math.random() * 18; // 10–28s
            const delay = Math.random() * 8; // 0–8s

            s.style.animationName = 'snowFallHKCM';
            s.style.animationTimingFunction = 'linear';
            s.style.animationIterationCount = 'infinite';
            s.style.animationDuration = `${duration}s`;
            s.style.animationDelay = `${delay}s`;

            s.style.fontSize = 8 + Math.random() * 14 + 'px';
            s.style.filter = Math.random() > 0.5 ? 'blur(0.5px)' : 'none';
            s.textContent = Math.random() > 0.6 ? '❄️' : Math.random() > 0.3 ? '✦' : '•';

            host.appendChild(s);
            cleanup.push(() => host.contains(s) && host.removeChild(s));
        }
    }

    if (twHost) {
        for (let i = 0; i < twinkles; i++) {
            const t = document.createElement('div');
            t.className = 'twinkle';
            t.style.left = Math.random() * 100 + 'vw';
            t.style.top = Math.random() * 40 + 'vh';
            t.style.animationDelay = Math.random() * 5 + 's';
            t.style.transform = `scale(${0.6 + Math.random() * 0.8})`;

            twHost.appendChild(t);
            cleanup.push(() => twHost.contains(t) && twHost.removeChild(t));
        }
    }
});

onBeforeUnmount(() => {
    cleanup.forEach((fn) => fn());
    cleanup = [];
});
</script>

<style>
@keyframes snowFallHKCM {
    0% {
        transform: translateY(-10vh);
    }
    100% {
        transform: translateY(110vh);
    }
}

:global(.snowflake) {
    position: absolute;
    pointer-events: none;
    color: rgba(255, 255, 255, 0.8);
    will-change: transform;
}
</style>
